import { useTranslation } from "react-i18next";

const BorrowerAuthorizationConsent = (props) => {
  const dateFormatOptions = {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  };
  const currentDate = new Date().toLocaleDateString("en-US", dateFormatOptions);
  const { t } = useTranslation();

  const consentHtml = t("borrowerAuthorizationConsentText")
    ?.replace(/&nbsp;/g, "\u00A0")
    .replace(/<strong>/g, "<b>")
    .replace(/<\/strong>/g, "</b>")
    .replace("{currentDate}", currentDate)
    .split("\n")
    .join("<br/>");

  return (
    <div>
      <h4>{t("Borrower's Certification & Authorization")}</h4>
      <h5>{props?.coBorrowerFullName}</h5>
      <div
        className="textClassName"
        style={{ whiteSpace: "pre-wrap" }}
        dangerouslySetInnerHTML={{ __html: consentHtml }}
      />
    </div>
  );
};

export default BorrowerAuthorizationConsent;
